import { parseMDX } from "@/lib/mdx"
import LegalScene from "@/scenes/LegalScene"
import markdown from "~/i18n/es/terms_conditions.md"

export default function TerminosCondiciones({ content }) {
  return <LegalScene title="Mi Coche De Renting - Términos y condiciones" pageName="terms" markdown={content} />
}

export async function getStaticProps() {
  const parsedMdx = await parseMDX(markdown)
  return { props: { content: parsedMdx } }
}
